import React, { useEffect } from 'react'
import { AiOutlineCalendar } from "react-icons/ai";
import { useDispatch, useSelector } from 'react-redux';
import { Spin } from 'antd';
import dayjs from 'dayjs';

import Charts from './chart';

import { DashboardWrapper } from './style';
import { GetGraphStats, GetTileStats } from '../../slices/packing-stats';

const Dashboard = () => {
  const dispatch = useDispatch();

  const {
    fetchingTileStats,
    tileStats,
  } = useSelector((state) => state.packingStats || {});

  useEffect(() => {
    const startDate = dayjs().subtract(29, 'day').startOf('day').format('YYYY-MM-DD');
    const endDate = dayjs().endOf('day').format('YYYY-MM-DD');

    dispatch(GetTileStats());
    dispatch(GetGraphStats({ startDate, endDate, type: 'day' }));
  }, []);

  const { prepStats, receivedStats } = tileStats || {};

  return (
    <DashboardWrapper>
      <Spin tip='Loading...' spinning={fetchingTileStats}>
        <div className='cards-items'>
          {receivedStats?.map(({
            label,
            totalItemUnits,
            totalItemUniqueCount,
          }, index) => (
            <div key={index} className='items-wrapper'>
              <header>
                <AiOutlineCalendar />
                <h6>{label}</h6>
              </header>
              <div className='items'>
                <div className='content'>
                  <p>Received / Prep</p>
                  <p>{totalItemUnits || 0} / {prepStats[index]?.units_prepared || 0}</p>
                </div>
                <div className='content'>
                  <p>SKUs</p>
                  <p>{totalItemUniqueCount || 0} / {prepStats[index]?.sku_count || 0}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </Spin>
      <Charts />
    </DashboardWrapper>
  )
}

export default Dashboard;
